export default __webpack_public_path__ + "static/media/clear.6befa83f.mp3";